import { useEffect } from "react"
import { batch, useComputed, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { DATE_PERIODS, GROUPED_BY } from "@constants"
import { commonFiltersValue, groupedBy, isLoadingCommonFilters, sku } from "@signals"
import { useSkuDetailsRoleConfig } from "Pages/SkuDetails/@hooks"


export default function useStockChangesPriceEvolutionData() {
	const { showToast } = useAppToast()
	const { urlApiPricingEvolution } = useSkuDetailsRoleConfig()

	const dataEvolution = useSignal({})
	const dataEvolutionFiltered = useComputed(() => dataEvolution.value ? dataEvolution.value[selectValue.value] : null)
	const dataEvolutionKeys = useSignal({})
	const dataEvolutionKeysFiltered = useComputed(() => {
		return dataEvolutionKeys.value ? dataEvolutionKeys.value[selectValue.value] : []
	})

	const currency = useComputed(() => currencies.value ? currencies.value[selectValue.value] : '')
	const chartSphereColors = useSignal({})
	const chartColors = useSignal({})
	const skuName = useSignal("")
	const retailer = useSignal("")
	const isLoadingDataEvolution = useSignal(false)
	const currencies = useSignal({})
	const evolutionDatePeriod = useSignal(DATE_PERIODS.LAST_7_DAYS)
	const pricingGroupBy = useSignal([GROUPED_BY.COUNTRY])
	const selectOptions = useSignal([])
	const selectValue = useSignal(null)


    useEffect(() => {
		batch(() => {
			if (sku.value && (isLoadingCommonFilters.value || pricingGroupBy.value != groupedBy.value)){
				isLoadingDataEvolution.value = true
				getDataEvolution()
			}
		})
	}, [isLoadingCommonFilters.value, groupedBy.value])

	const getDataEvolution = () => {
		dataEvolution.value = {}
		if (groupedBy.value === GROUPED_BY.COUNTRY)
			pricingGroupBy.value = [GROUPED_BY.COUNTRY]

		if (groupedBy.value === GROUPED_BY.RETAILER)
			pricingGroupBy.value = [GROUPED_BY.COUNTRY, GROUPED_BY.RETAILER]
		
		postSubmit(urlApiPricingEvolution, { ...commonFiltersValue.value, groupedBy: pricingGroupBy.value })
			.then(res => batch(() => {
				dataEvolution.value = res.chartData
				dataEvolutionKeys.value = res.chartKeys
				chartSphereColors.value = res.chartColorsSphere
				chartColors.value = res.chartColors
				skuName.value = res.skuName
				selectOptions.value = res.selectOptions || []
        		selectValue.value = res.selectOptions && res.selectOptions.length > 0 ? res.selectOptions[0].value : ''
				currencies.value = res.currency
				retailer.value = res.retailer
				isLoadingDataEvolution.value = false
			}))
			.catch(() => {
				showToast.error()
			})
			.finally(() => {
				isLoadingDataEvolution.value = false
			})
	}

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		chartColors.value = {}
		skuName.value = ""
		retailer.value = ""
		currencies.value = {}
		evolutionDatePeriod.value = DATE_PERIODS.LAST_7_DAYS
	})

	const handleChangeEvolutionSelect = (e) => batch(() => {
		isLoadingDataEvolution.value = true
		setTimeout(() => {
			isLoadingDataEvolution.value = false
		}, 0.1)
		selectValue.value = e.target.value
		
	})

	return {
		dataEvolution: dataEvolution.value,
		dataEvolutionFiltered: dataEvolutionFiltered.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeysFiltered.value,
		currency: currency.value,
		skuName: skuName.value,
		evolutionDatePeriod: evolutionDatePeriod.value,
		chartColors: chartColors.value,
		chartSphereColors: chartSphereColors.value,
		retailer: retailer.value,
		selectOptions: selectOptions.value,
		selectValue: selectValue.value,
        resetEvolutionData,
		handleChangeEvolutionSelect
	}
}